import type { ChatMessage } from '../../store/types'

// Slack-style threads (docs/chat-threads-plan.md), client side.
//
// Every message the app knows about — channel message or thread reply — lives in
// its room's one list in the store (chatMessages[roomID]). The channel screen
// and the thread screen are two filters over that list. Keeping one list means
// edit, delete, reactions, optimistic sends and dedupe (all keyed by room + id)
// work for thread replies with no special cases.

// Shows in the channel: a channel message, or a thread reply that was also sent
// to the channel. Mirrors the server's chatChannelVisible.
export function isChannelVisible(m: ChatMessage): boolean {
  return !m.thread_root_id || !!m.also_in_channel
}

// The channel view of a room's messages.
export function channelMessages(all: ChatMessage[]): ChatMessage[] {
  return all.filter(isChannelVisible)
}

// A thread's first message (if we hold it) and its replies, in order.
export function threadMessages(
  all: ChatMessage[],
  rootID: string,
): { root: ChatMessage | undefined; replies: ChatMessage[] } {
  return {
    root: all.find((m) => m.id === rootID),
    replies: all.filter((m) => m.thread_root_id === rootID),
  }
}

// "1 reply" / "4 replies".
export function replyCountLabel(n: number): string {
  return n === 1 ? '1 reply' : `${n} replies`
}

// Drafts are kept per room and per thread (see drafts.ts): a thread's unsent
// reply must not appear in the room's composer, or the other way round.
export function draftKey(roomID: string, threadRootID?: string): string {
  return threadRootID ? `${roomID}#thread:${threadRootID}` : roomID
}
